module.exports = {"priceNote":"*A service fee will be added to this transaction.","getDirections":"Get directions - FR","showMore":"Show more - FR","showLess":"Show less - FR","presentedBy":"Presented by - FR"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/Flexpass/FlexpassDetails/locales/fr.json
// module id = 1135
// module chunks = 0